import { api } from './client';

/** Mirrors ImprestSheetDto + commands (Api/UseCases/Payroll/ManageImprestSheets). */
export interface ImprestItemDto {
  id: number;
  workerId: number;
  workerName: string;
  contractNumber: number;
  contractSerial: string;
  amount: number;
  paidOutDate: string | null;
}

export interface ImprestSheetDto {
  id: number;
  year: number;
  month: number;
  sheetDate: string;
  isPosted: boolean;
  documentNumber: string;
  journalEntryId: number | null;
  items: ImprestItemDto[];
}

export const imprestsApi = {
  list: (year: number, month: number) =>
    api.get<ImprestSheetDto[]>('/payroll/imprests', { year, month }),

  save: (year: number, month: number, sheetDate: string, items: { workerId: number; contractNumber: number; contractSerial?: string | null; amount: number }[]) =>
    api.post<number>('/payroll/imprests', { year, month, sheetDate, items }),

  post: (sheetId: number) =>
    api.post<number>(`/payroll/imprests/${sheetId}/post`, {}),

  markItemPaid: (sheetId: number, itemId: number, paidOutDate: string) =>
    api.post<void>(`/payroll/imprests/${sheetId}/items/${itemId}/mark-paid?paidOutDate=${paidOutDate}`, {}),

  runHolidayReserve: (reserveDate: string, accountCosts: number, accountReserve: number, totalSumChange: number) =>
    api.post<number>('/payroll/holiday-reserve', { reserveDate, accountCosts, accountReserve, totalSumChange }),
};
